import React, { HTMLAttributes } from 'react';
import Immutable from 'immutable';

import {
  WysiwygField,
  Container,
} from '@uncinc/uncinc-react-kitchen-sink';

import {
  Paragraph,
} from '@uncinc/react-drupal-core';

import {
  ReferenceField,
  ParagraphEntity as ParagraphType,
  ImmutableEntity,
} from '@uncinc/react-drupal-core/types';

import useClasses from '../../../../hooks/useClasses';
import { MediaFileField } from '../../../../types';

import './style.scss';

interface Props extends React.HTMLProps<HTMLAttributes<HTMLDivElement>> {
  title: string;
  body: string;
  svg?: ImmutableEntity<MediaFileField>;
  paragraphs:
  Immutable.List<ReferenceField<ParagraphType>[] & ImmutableEntity<ReferenceField<ParagraphType>>>;
}

const FrontPageHero: React.FC<Props> = ({
  title,
  body,
  svg,
  paragraphs,
  className,
}) => {
  const { buildClass, joinClasses } = useClasses('FrontPageHero');

  const svgDescription = svg.get('description', '');
  const svgSource = svg.get('url', '');

  const gridClassesPrograms = 'col-lg-10 col-md-12 col-sm-12 col-12 offset-lg-1';
  const gridContentText = 'col-lg-6 offset-lg-1 order-lg-1 col-md-7 order-md-1 offset-md-1 col-sm-12 order-sm-0';
  const gridContentMedia = 'col-lg-3 order-lg-2 offset-lg-1 col-md-4 order-md-2 col-sm-12 order-sm-0';

  return (
    <div className={joinClasses(buildClass(), className)}>
      <Container>
        <div className="row flex-alignment">
          <div className={joinClasses(buildClass('media-wrapper'), gridContentMedia)}>
            <div className={buildClass('media-wrapper')}>
              { svg && <img width="100%" src={svgSource} alt={svgDescription} /> }
            </div>
          </div>
          <div className={gridContentText}>
            <h1 className={buildClass('title')}>
              { title }
            </h1>
            {body && (
              <WysiwygField
                className={buildClass('body')}
                property="schema:text"
                html={body}
              />
            )}
          </div>
        </div>
        <div className="row">
          <div className={joinClasses(buildClass('programs-container'), gridClassesPrograms)}>
            {paragraphs.size > 0 && (
              <div className={buildClass('paragraphPrograms')}>
                {paragraphs.map((paragraph) => {
                  const id = paragraph.get('target_id');
                  const language = paragraph.getIn(['entity', 'langcode', 0, 'value']);
                  return (
                    <Paragraph
                      key={`paragraph:${id}:${language}`}
                      id={id}
                      entity={paragraph.get('entity')}
                    />
                  );
                })}
              </div>
            )}
          </div>
        </div>
      </Container>
    </div>
  );
};

export default FrontPageHero;
